import { Controller } from "@hotwired/stimulus";
import { STEP_TO_EVENT_MAP, PACKAGE_MATRIX } from "./tracking/data";

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const getHeapInstance = async (
  attempt = 1,
  maxAttempts = 5,
  interval = 200
) => {
  if (window.heap?.track) return window.heap ?? null;
  if (attempt > maxAttempts) return null;
  return wait(interval).then(() => getHeapInstance(attempt + 1));
};

export default class extends Controller {
  static values = { data: Object };

  trackStep(event) {
    const step = event.detail?.step;

    if (!step) return;

    const eventName = STEP_TO_EVENT_MAP[step];
    if (!eventName || !this.hasDataValue) return;

    const packageSlug = event.detail?.packageSlug;
    const price = event.detail?.price;

    const packageData = PACKAGE_MATRIX[packageSlug];

    if (!packageData) return;
    const properties = { ...packageData, price, step_name: step };

    this._track(eventName, properties);
  }

  track({ params: { eventName, properties } }) {
    if (!eventName) return;

    this._track(eventName, properties);
  }

  async _track(eventName, properties) {
    const heap = await getHeapInstance();

    if (heap) {
      heap.track(eventName, properties);
    }
  }
}
